/**
 * Shared horizontal padding (theme spacing units) for fragment card content
 * and card media overlays so content and pills align.
 * 1.5 for viewports < xl, 2 for xl and up.
 */
export const FRAGMENT_CARD_PADDING_X = { xs: 1, md: 1.5, xl: 2 };

/** Grid view modes (list uses single-column layout, not this map). Aligns with ItemsViewLayout grid keys. */
export type FragmentGridViewMode = 'gridWide' | 'gridNormal' | 'gridCompact';

/**
 * Grid breakpoints per view mode. Uses 60 columns for finer control (e.g. 5 items per row).
 * 60 allows: 2→30, 3→20, 4→15, 5→12, 6→10 cols per row.
 */
export const FRAGMENTS_GRID_ITEM_PROPS_BY_VIEW_MODE: Record<
  FragmentGridViewMode,
  { xs: 60; sm: number; md: number; lg: number; xl: number }
> = {
  gridWide: { xs: 60, sm: 30, md: 20, lg: 20, xl: 15 },
  gridNormal: { xs: 60, sm: 30, md: 20, lg: 15, xl: 12 },
  gridCompact: { xs: 60, sm: 30, md: 20, lg: 12, xl: 10 },
};

/** Spacing between grid items in the fragments grid. */
export const FRAGMENTS_GRID_SPACING = {
  md: 2,
  lg: 3,
  xl: 4,
};

/** Number of skeleton cards shown while the fragments list is loading. */
export const FRAGMENTS_LIST_SKELETON_CARD_COUNT = 8;

/** Number of skeleton cards shown while the fragments grid is loading. */
export const FRAGMENTS_GRID_SKELETON_CARD_COUNT = 15;

/** List view: width (px) of the media column in list layout cards. */
export const FRAGMENT_LIST_CARD_MEDIA_WIDTH = {
  md: 180,
  lg: 180,
  xl: 200,
};

/** List view: max width and centering. Used by list card and list section container. */
export const FRAGMENT_LIST_CONTAINER_SX = {
  maxWidth: 'xl' as const,
};
